module.exports = __webpack_public_path__ + "static/media/nag3.9dee3ded.png";